import type { CustomDetailDataTypeEnum } from '@dealstack/shared/lib/generated';

export const CUSTOM_DETAILS_WORKSHEET_NAME = 'custom-details';

type CustomDetailDataTypeName = `${CustomDetailDataTypeEnum}`;

export const PERSON_BACKED_CUSTOM_DETAIL_DATA_TYPES = [
	'TAX_RESIDENCY',
	'TIN',
	'COUNTRY_OF_BIRTH',
] as const satisfies readonly CustomDetailDataTypeName[];

const personBacked: ReadonlySet<string> = new Set<string>(PERSON_BACKED_CUSTOM_DETAIL_DATA_TYPES);

export const isPersonBackedCustomDetailDataType = (dataType: string): boolean =>
	personBacked.has(dataType);
